import React, { useEffect, useState, useRef } from 'react';

import './index.module.less';

import { isWebInApp } from '@helpers/Constants';

import BrowserHistory, { canGo } from '@helpers/BrowserHistory';
import { getNativeProxySington } from '@helpers/NativeProxy';
import FridayService from '@services/friday';
import Filter from '@helpers/Filter';
import { isCubeApp } from '@helpers/Constants';
import { systemAppCode } from '../constant';
import { getExplanationList, getRiskList } from '../utils';

import NavBar from '@components/NavBar';
import CommonBtn from '@components/CommonBtn';

interface IProps {
  onNext: () => void;
}

const Agreement = (props: IProps) => {
  const { onNext } = props;
  const params = useRef<{ appCode?: string; roleType?: string }>(
    Filter.urlParams(window.location.search),
  );
  const code = isCubeApp() ? systemAppCode.cubeApp : params.current.appCode;
  const explanation = getExplanationList(code, params.current.roleType);
  const riskList = getRiskList(code, params.current.roleType);

  const [check, setChecked] = useState(false);
  const next = () => {
    onNext && onNext();
    FridayService.addEvent('log_out_of_account_next_click');
  };

  const handleCheck = () => {
    setChecked(!check);
  };

  const back = async () => {
    // const isMiniProgram = window?.__wxjs_environment === 'miniprogram';
    // if(isMiniProgram) {
    //   window.wx.miniProgram.navigateBack();
    //   return;
    // }
    if (isWebInApp() && !canGo(-1)) {
      const np = await getNativeProxySington('seewoCube');
      await np.asyncInvoke({
        name: 'postMessage',
        params: {
          command: 'command_close_container',
          extras: {},
        },
      });
    }
    BrowserHistory.goBack();
  };
  useEffect(() => {
    return () => {
      window.scrollTo(0, 0);
    };
  }, []);

  return (
    <div styleName="container">
      <NavBar
        title="注销帐号"
        onClickBackBtn={back}
        hideBackButton={window?.__wxjs_environment === 'miniprogram'}
      />
      <div className="flex" styleName="tips">
        <i className="iconfont icon-info" />
        <div>
          注销帐号是不可恢复的操作（即抹除全部数据）。因此，在操作前，请仔细阅读以下内容。
        </div>
      </div>
      {
        explanation?.length > 0 &&
        <>
          <div styleName="tips-title">
            申请注销安全保护
            <div styleName="tips-block"></div>
          </div>

          <div styleName="tips-desc">
            提交注销前，请进行以下校验，以保证您的帐号安全：
          </div>
          {explanation.map((item, index) => {
            return (
              <div styleName="explanation" key={item.title}>
                <div styleName="explanation-title">
                  <span styleName="num">{'0' + (index + 1)}</span>
                  {item.title}
                </div>
                <div styleName="explanation-content">{item.content}</div>
              </div>
            );
          })}
        </>
      }
      <div styleName="tips-title" style={{ width: '2.2rem' }}>
        注销风险确认
        <div styleName="tips-block"></div>
      </div>

      <div styleName="tips-desc">注销帐号存在以下风险，请进行确认：</div>
      {riskList.map((item, index) => {
        return (
          <div styleName="explanation" key={item.title}>
            <div styleName="explanation-title">
              <span styleName="num">{'0' + (index + 1)}</span>
              {item.title}
            </div>
            <div styleName="explanation-content">{item.content}</div>
          </div>
        );
      })}
      <div styleName="check-box">
        <div
          styleName={`check-icon ${check ? 'agree' : 'un-agree'}`}
          onClick={handleCheck}
        ></div>
        <div styleName="check-tip">
          我已阅读<span style={{ color: '#222326' }}>《风险确认》</span>
          并同意注销帐号
        </div>
      </div>
      <div styleName="explanation" style={{ marginBottom: '1.6rem' }}></div>
      <CommonBtn
        onConfirm={next}
        disabled={!check}
        btnText="下一步"
        type="fixed"
      />
    </div>
  );
};

export default Agreement;
